
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useGameParameter } from '@/modules/game/parameter/model/edit';
import { ROUTE_NAME_GAME } from '@/modules/game/router';

export default defineComponent({
    name: ROUTE_NAME_GAME.PARAMETER,
    components: { AppFormRow, AppInput, AppCard, AppButton },
    setup() {
        const { model, v$, fetch, actions } = useGameParameter();

        onMounted(async () => {
            await fetch();
        });

        return { model, v$, actions };
    }
});
